import {
  FormControl,
  TextField as MaterialTextField,
  FormLabel,
  styled,
} from "@mui/material";
import { TextFieldProps } from ".";
import InputAdornment from "@mui/material/InputAdornment";

const TextField = ({
  label,
  fullWidth,
  readOnly,
  required,
  InputProps,
  icon,
  iconPosition = "end",
  onClickIcon,
  maxLength,
  variant = "outlined",
  className = "",
  onKeyEnter,
  ...props
}: TextFieldProps) => {
  return (
    <FormControl
      disabled={props.disabled}
      fullWidth={fullWidth}
      required={required}
    >
      {label && <FormLabel>{label}</FormLabel>}
      <StyledMaterialTextField
        {...(maxLength && { inputProps: { maxLength } })}
        inputProps={{ maxLength }}
        InputProps={{
          ...InputProps,
          ...(icon && {
            [`${iconPosition}Adornment`]: (
              <InputAdornment
                position={iconPosition}
                sx={
                  iconPosition === "start"
                    ? {
                        marginLeft: "10px",
                        cursor: onClickIcon ? "pointer" : "auto",
                      }
                    : {
                        marginRight: "10px",
                        cursor: onClickIcon ? "pointer" : "auto",
                      }
                }
                onClick={onClickIcon}
              >
                {icon}
              </InputAdornment>
            ),
          }),
          readOnly,
        }}
        className={`${variant} ${className}`}
        variant={variant === "borderless" ? "outlined" : variant}
        {...props}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onKeyEnter?.();
          }
        }}
      />
    </FormControl>
  );
};

export default TextField;

const StyledMaterialTextField = styled(MaterialTextField)(({ theme }) => ({
  "&.borderless div": {
    border: "none",
    input: {
      height: "18px",
    },
    ".MuiInputAdornment-root": {
      fill: theme.tokens.colors.gray[6],
      opacity: 0,
      height: "1rem",
      marginRight: 0,
      display: "none",
    },
    "input::placeholder": {
      fontSize: "14px",
      fontFamily: "'Nunito', sans-serif",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "18px",
    },
    "input:placeholder-shown ~ .MuiInputAdornment-root": {
      opacity: 1,
      display: "block",
    },
  },
}));
